export default __webpack_public_path__ + "static/media/actionHelper.dd977b72.svg";